(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["einhorn-svg-heading"] && !Shopify.designMode) return;
  try {
    function wrapText(svgElement) {
    const maxWidth = svgElement.clientWidth;
    if (!maxWidth) return; // bail if SVG has no width yet (layout not ready)

    const textElement = svgElement.querySelector('text');

    let originalText = textElement.dataset.originalText;
    if (!originalText) {
      originalText = textElement.textContent.trim();
      textElement.dataset.originalText = originalText;
    }

    textElement.innerHTML = '';
    textElement.textContent = originalText;

    const textBBoxTest = textElement.getBoundingClientRect();
    if (!textBBoxTest.height) return; // bail if measurement failed (element not visible yet)

    if (textBBoxTest.width <= maxWidth) {
      textElement.setAttribute('y', '70%');
      svgElement.style.height = `${textBBoxTest.height}px`;
      return;
    }

    const text = textElement.textContent.trim();
    const words = text.split(/[\s-]+/);
    textElement.textContent = '';

    let i = 0;
    let dy = 0;
    const x = textElement.getAttribute('x') || '0';

    while (i < words.length) {
      let line = words[i];
      let j = i + 1;

      while (j < words.length) {
        const testLine = line + ' ' + words[j];
        const testTspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        testTspan.textContent = testLine;
        textElement.appendChild(testTspan);
        const tooWide = testTspan.getComputedTextLength() > maxWidth;
        textElement.removeChild(testTspan);
        if (tooWide) break;
        line = testLine;
        j++;
      }

      const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
      tspan.setAttribute('x', x);
      tspan.setAttribute('dy', dy === 0 ? '0em' : '1.16em');
      tspan.textContent = line;
      textElement.appendChild(tspan);
      dy++;
      i = j;
    }

    const lineCount = textElement.querySelectorAll('tspan').length;
    const yValues = { 1: '70%', 2: '42.5%', 3: '30%' };
    textElement.setAttribute('y', yValues[lineCount] || '20%');

    const textBBox = textElement.getBoundingClientRect();
    svgElement.style.height = `${textBBox.height}px`;
  }

  const watchedSvgs = new WeakSet();

  function watchSvg(svg) {
    if (watchedSvgs.has(svg)) return;
    watchedSvgs.add(svg);

    let pending = null;
    const ro = new ResizeObserver(() => {
      if (pending !== null) cancelAnimationFrame(pending);
      pending = requestAnimationFrame(() => {
        pending = null;
        ro.unobserve(svg);
        wrapText(svg);
        // reconnect after one more frame so wrapText's own height change doesn't re-trigger
        requestAnimationFrame(() => ro.observe(svg));
      });
    });

    document.fonts.ready.then(() => {
      wrapText(svg);
      requestAnimationFrame(() => ro.observe(svg));
    });
  }

  function updateSvgHeadings() {
    document.querySelectorAll('.section-heading-svg').forEach(svg => watchSvg(svg));
  }

  document.addEventListener('DOMContentLoaded', updateSvgHeadings);
  document.addEventListener('shopify:section:load', updateSvgHeadings);
  } catch(e) { console.error(e); }
})();

})();
